import { generateQueryKey } from '../../app/utils/react-query-utils';

enum QueryKeyIdentifier {
    FAMILY_TREE = 'FAMILY_TREE',
}

export const queryKeys = {
    familyTree: (partnerUuid?: string) => generateQueryKey(QueryKeyIdentifier.FAMILY_TREE, 'ITEM', partnerUuid),
};
